module.exports = __webpack_public_path__ + "static/media/head.0c11cf45.svg";